
import parse from "date-fns/parse"
import format from "date-fns/format"

export const TIME_FORMAT = "HH:mm";
export const DATE_FORMAT = "dd.MM.yyyy";

export const DATE_TIME_FORMAT = "dd.MM.yyyy HH:mm";

export const STRICT_HOUR_ROUNDING_VALUE_REGEX = "[0-23]";

export const STRICT_TIME_REGEX = "^[0-2][0-9]:[0-5][0-9]";
export const STRICT_DATE_REGEX = "[0-3][0-9]\.[0-1][0-9]\.[0-9]{4}";



export const dateDataToDate = (value: string | undefined, schemaFormat: "date" | "time" | "date-time") => {
    if (!value) {
        return
    }
    try {
        if (schemaFormat === "date") {
            return parse(value, DATE_FORMAT, new Date())
        }

        if (schemaFormat === "time") {
            return parse(value, TIME_FORMAT, new Date())
        }

    } catch (error) {
        return new Date(value)
    }
    if (schemaFormat === "date-time") {
        return new Date(value)
    }
}

const inputToDate = (value?: string) => {
    if (!value) {
        return;
    };
    try {
        if (RegExp(STRICT_TIME_REGEX).test(value)) {
            return parse(value, TIME_FORMAT, new Date())
        };
        if (RegExp(STRICT_DATE_REGEX).test(value)) {
            return parse(value, DATE_FORMAT, new Date())
        };
        return new Date(value)
    } catch (error) {
        return
    }
};

export const dateValueToFormat = (value: string | undefined, schemaFormat: "date" | "time" | "date-time") => {
    const valueAsDate = inputToDate(value);
    if (!valueAsDate) {
        return
    }

    if (schemaFormat === "date") {
        return format(valueAsDate, DATE_FORMAT)
    }

    if (schemaFormat === "time") {
        return format(valueAsDate, TIME_FORMAT)
    }

    if (schemaFormat === "date-time") {
        return format(valueAsDate, DATE_TIME_FORMAT)
    }
}